import { mapGetters, mapState } from 'vuex'
import axios from 'axios'
import chatBookingHelpers from '../helpers/chatBookingHelpers'
import loginHelpers from '../helpers/loginHelpers'

export const chatBookingMixin = {
  data () {
    return {
      chatBookingId: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser'
    }),
    ...mapState('chatBooking', ['bookingData']),
    ...mapState('payment', [
      'tmpOmiseChargeId',
      'tmpOmiseToken',
      'tmpIsDefaultCard'
    ])
  },
  methods: {
    async checkOmiseTestCharge () {
      const url = `/payments/${this.user.id}/check-omise-test-charge`
      const { data } = await axios.post(url, { omise_charge_id: this.tmpOmiseChargeId })
      if (data) {
        const omiseTestCharge = data.omise_test_charge
        switch (omiseTestCharge.status) {
          case 0:
            setTimeout(() => {
              this.checkOmiseTestCharge()
            }, 2000)
            break
          case 1:
            this.saveNewCard()
            break
          case 2:
            this.$store.commit('payment/SET_TMP_OMISE_CHARGE_ID', null)
            const message = `${this.$i18n.t('message.booking.payment_step.payment_cannot_save_credit_card')} ${omiseTestCharge.failure_message}`
            this.$swal({ text: message, type: 'error' })
            break
        }
      }
    },
    saveNewCard () {
      const url = 'payments'
      const submitData = {
        user_id: this.user.id,
        omise_token: this.tmpOmiseToken,
        chat_booking_id: this.chatBookingId,
        is_default: this.tmpIsDefaultCard
      }
      axios.post(url, submitData)
        .then(res => {
          const response = res.data
          if (!response.error) {
            const omiseCustomerId = response.omise_customer_id
            // Update omise customer id and clear tmp omise token
            this.$store.commit('chatBooking/UPDATE_BOOKING_DATA', {omise_customer_id: omiseCustomerId})
            this.$store.commit('payment/SET_TMP_OMISE_CHARGE_ID', null)
            this.$store.commit('payment/SET_TMP_OMISE_TOKEN', null)
            // Get full order data of chat booking for adding new order
            this.getFullOrderData()
          }
        })
        .catch(error => {
          console.log(error)
          this.$swal({text: error.message, type: 'error'})
        })
    },
    getFullOrderData () {
      if (this.chatBookingId) {
        const url = `chat-bookings/${this.chatBookingId}/full-order-data`
        const params = {
          payment_method: 'credit_card',
          omise_customer_id: this.bookingData.omise_customer_id,
          total_price: this.bookingData.total_price,
          service_vat: this.bookingData.service_vat,
          discount_cost: this.bookingData.discount_cost,
          credit_discount_cost: this.bookingData.credit_discount_cost,
          is_credit: this.bookingData.is_credit,
          promo_code_id: this.bookingData.promo_code_id
        }
        axios.post(url, params)
          .then(res => {
            const response = res.data
            if (!response.error) {
              const fullOrderData = response.full_order_data
              if (fullOrderData.package_type_id === null) {
                // Add new order data
                this.addOrder(fullOrderData)
              } else {
                this.addPackage(fullOrderData)
              }
            }
          })
          .catch(error => {
            console.log(error)
            this.$swal({text: error.message, type: 'error'})
          })
      }
    },
    addOrder (orderData) {
      const url = 'orders'
      axios.post(url, orderData)
        .then(res => {
          const response = res.data
          if (!response.error) {
            // Delete chat booking data when order is added
            this.deleteChatBooking()
          }
        })
        .catch(error => {
          console.log(error)
          this.$swal({text: error.message, type: 'error'})
        })
    },
    addPackage (orderData) {
      const url = 'packages'
      axios.post(url, orderData)
        .then(res => {
          const response = res.data
          if (!response.error) {
            // Delete chat booking data when order is added
            this.deleteChatBooking()
          } else {
            this.$swal({text: response.message, type: 'error'})
          }
        })
        .catch(error => {
          console.log(error)
          this.$swal({text: error.message, type: 'error'})
        })
    },
    deleteChatBooking () {
      const url = `chat-bookings/${this.chatBookingId}`
      axios.delete(url)
        .then(res => {
          const response = res.data
          if (!response.error) {
            this.$store.commit('chatBooking/CLEAR_MESSAGES', true)
            // Send auto reply message to user
            const message = {
              sender_type: 'user',
              type: 'text',
              label: 'success-credit-card',
              text: 'ยืนยันการชำระเงินด้วยบัตรเครดิต/เดบิต'
            }
            this.$store.commit('chatBooking/ADD_MESSAGE', message)
          }
        })
        .catch(error => {
          console.log(error)
          this.$swal({text: error.message, type: 'error'})
        })
    },
    loginUser (params) {
      const url = `chat-bookings/login`
      const submitData = {
        user_id: params.user_id,
        validation: params.validation
      }
      axios.post(url, submitData)
        .then(res => {
          const response = res.data
          if (!response.error) {
            const user = response.user
            // Set user data and jwt token
            loginHelpers.setLoginData(response)

            const message = {
              sender_type: 'user',
              type: 'text',
              label: 'my-professional',
              text: `ตรวจสอบคิวว่างของผู้ให้บริการของคุณ ${user.full_name}`,
              data: `user_id=${user.id}`
            }
            this.$store.commit('chatBooking/ADD_MESSAGE', message)
          } else {
            this.$store.commit('chatBooking/INIT_MESSAGE', null)
          }
        })
        .catch(error => {
          console.log(error)
          this.$swal({text: error.message, type: 'error'})
        })
    }
  },
  async mounted () {
    this.chatBookingId = null
    const queryParams = this.$route.query
    // Perform omise refund and remove temp omise_charge_id and omise_token
    if (this.$route.query.chat_booking_id && this.tmpOmiseToken) {
      this.chatBookingId = this.$route.query.chat_booking_id
      // Check omise test charge
      await this.checkOmiseTestCharge()
    } else {
      this.$store.commit('chatBooking/CLEAR_MESSAGES', true)
      if (this.user) {
        // Route B: start with select professional
        if (queryParams.route === 'select-professional-first') {
          const params = {
            user: this.user,
            route: queryParams.route
          }
          chatBookingHelpers.fetchChatBooking(params)
        } else if (queryParams.route === 'logout') {
          const message = {
            sender_type: 'user',
            type: 'text',
            label: 'request-logout',
            text: `${this.user.name} ต้องการออกจากระบบ`,
            data: `user_id=${this.user.id}`
          }
          this.$store.commit('chatBooking/ADD_MESSAGE', message)
        } else {
          // Route A: start with new booking
          const params = {
            user: this.user,
            route: queryParams.route
          }
          chatBookingHelpers.fetchChatBooking(params)
        }
      } else {
        // Route B: start with select professional and login user with user_id and validation
        if (queryParams.route === 'select-professional-first' && queryParams.user_id && queryParams.validation) {
          this.loginUser(queryParams)
        } else {
          this.$store.commit('chatBooking/INIT_MESSAGE', null)
        }
      }
    }

    // Keep log when having referral code in query params
    chatBookingHelpers.keepLog(queryParams)
  },
  created () {
    // Set redirect url for LINE registration
    if (this.user) {
      let queryParams = this.$route.query
      queryParams.redirect_url = `https://beneat.co/chat-booking?user_id=${this.user.id}`
      // console.log('DEBUG', queryParams)
      if (queryParams.code) {
        this.$http.get('line/login', {params: queryParams})
          .then(response => {
            return response.json()
          })
          .then(response => {
            console.log('DEBUG', response)
          }).catch(error => {
            console.log('DEBUG', error)
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/chatBookingMixin.js